/// <reference path="../_references.ts"/>

module App.History {
	import TitleBarService = App.Helpers.TitleBarService;
	import OfficeService = App.Utils.OfficeService;

	export class HistoryController {

		static $inject: string[] = ['$rootScope', '$scope', '$state' ,'TitleBarService', '$q', 'OfficeService', '$window', '$stateParams'];

		fromOffice: boolean = false;

		constructor(
			private $rootScope: App.Administrative.AppRootScope,
			private $scope: ng.IScope,
			private $state: ng.ui.IStateService,
			private TitleBarService: TitleBarService,
			private $q: ng.IQService,
			private OfficeService: OfficeService,
			private $window: ng.IWindowService,
			private $stateParams: ng.ui.IStateParamsService
		) {
			$rootScope.app.startAppLoading();

			TitleBarService.set('History');

			OfficeService.getAppointment().then(() => {
				this.fromOffice = true;
			}).finally(() => {
				$rootScope.app.stopAppLoading();
			});
		}

		historyItems: HistoryItem[] = [
			{
				displayName: 'Service Request History',
				sref: 'zipSolutions.history.servicerequest',
				srefAddress: 'zipSolutions.history.address.servicerequests',
				permission: 'web.field.history',
			},
			{
				displayName: 'Recommendations',
				sref: 'zipSolutions.history.recommendations',
				srefAddress: 'zipSolutions.history.address.recommendations',
				permission: 'web.field.history',
			},
			{
				displayName: 'Files',
				sref: 'zipSolutions.history.photos',
				srefAddress: 'zipSolutions.history.address.photos',
				permission: 'web.field.history',
			}
		];

		getSref(item: HistoryItem) {
			return this.$state.params.addressId
				? item.srefAddress
				: item.sref;
		}

		goBack() {
			if (!this.fromOffice) {
				this.$window.history.back();
			} else {
				this.$state.go(this.$state.current, this.$stateParams, { reload: true });
			}
		}
	}
}